import React, { FunctionComponent } from 'react';
import styled from 'styled-components';


const TopNavComponent: FunctionComponent = () =>
{
    return <TopNavWrapper/>
};

export default TopNavComponent;

const TopNavWrapper = styled.div`
  display: flex;
  flex-direction: row;

  z-index: 10;

  height: 48px;
  width: 100%;

  position: fixed;

  background-color: #333333;;
`;
